import React from "react";
import { Project } from "../types/inspector.types";

interface ProjectSwitcherModalProps {
  projects: Project[];
  currentProjectId: string;
  open: boolean;
  onClose: () => void;
  onSelect: (id: string) => void;
}

export default function ProjectSwitcherModal({
  projects,
  currentProjectId,
  open,
  onClose,
  onSelect,
}: ProjectSwitcherModalProps) {
  return (
    <div
      className={`modalOverlay${open ? " open" : ""}`}
      onClick={onClose}
      aria-modal="true"
      role="dialog"
      aria-label="Switch Project"
    >
      <div className="inspSheet" onClick={(e) => e.stopPropagation()}>
        <div className="modalHandle" />
        <div className="modalTitle">Switch Project</div>
        {projects.map((project) => (
          <div
            className={`projOption${project.id === currentProjectId ? " active" : ""}`}
            key={project.id}
            onClick={() => onSelect(project.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onSelect(project.id);
            }}
          >
            <div
              className={`projOptionDot${project.id === currentProjectId ? " active" : ""}`}
            />

            <div>
              <div className="projOptionName">{project.name}</div>
              <div className="projOptionMeta">{project.meta}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
